import { Overlay } from '@radix-ui/react-dialog';
import { useEffect } from 'react';

import { cn } from '~/lib/cn';

import { OVERLAY_CLASS } from './constants';

interface SlideOutOverlayProps {
  overlayRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

export function SlideOutOverlay({
  overlayRef,
  onClose: handleClose,
}: SlideOutOverlayProps) {
  // Animate the overlay into view when it mounts.
  useEffect(() => {
    overlayRef.current?.classList.add(OVERLAY_CLASS.show);
    overlayRef.current?.classList.remove(OVERLAY_CLASS.hide);
  }, [overlayRef]);

  return (
    <Overlay
      ref={overlayRef}
      className={cn(
        'size-full transition-all duration-300 ease-out bg-overlay',
        OVERLAY_CLASS.hide,
      )}
      onClick={handleClose}
      role="presentation"
      aria-hidden="true"
    />
  );
}

SlideOutOverlay.displayName = 'SlideOutOverlay';
